import { FormRow, MediumFormRow, BigFormRow } from 'framework/ui/layout';
import { Checkbox, CountryDropdown, DateInput, PhoneInput, TextArea, TextInput } from 'framework/form';
import { Box } from '@mui/material';
import useLedgerService from 'domain/finance/ledger/useLedgerService';
import { AccountInput } from 'domain/shared/ledger';
import { Divider } from '@mui/material';
import VendorContactsListInput from 'domain/finance/vendors/shared/inputs/VendorContactsInput/VendorContactsListInput';
import { useAuthorization } from 'framework/authorization';
import { VENDOR_UPDATE_PRIVILEGED_INFO } from 'domain/finance/vendors/constants';
import { EmployeeInput } from 'domain/shared/employee';

const EditVendorProfile = () => {
  const { searchInvoiceAccount } = useLedgerService();
  const { isGranted } = useAuthorization();
  const isPrivilegedUpdate = isGranted(VENDOR_UPDATE_PRIVILEGED_INFO);

  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);

  return (
    <Box
      sx={{
        '.editable-field__wrapper': {
          marginBottom: '10px',
        },
        '.MuiFormControl-root': {
          marginBottom: '10px',
        },
      }}
    >
      <FormRow colXl={9}>
        <TextInput disabled={!isPrivilegedUpdate} source="vendorName" label="" placeholder="Vendor name" />
      </FormRow>

      <FormRow colXl={6}>
        <CountryDropdown disabled={!isPrivilegedUpdate} label="" placeholder="Vendor country" source="country" />
        <EmployeeInput isInitialNameLoad label="Owner" source="owner" disabled={!isPrivilegedUpdate} />
      </FormRow>

      <MediumFormRow>
        <TextInput
          disabled={!isPrivilegedUpdate}
          label=""
          placeholder="Tax registration number"
          source="taxRegistrationNumber"
        />
        <AccountInput
          disabled={!isPrivilegedUpdate}
          source="costCenterId"
          label=""
          placeholder="Cost center"
          cacheKey="vendor-accounts"
          loadDataMethod={searchInvoiceAccount}
        />
      </MediumFormRow>

      <MediumFormRow>
        <Checkbox isVisible={isPrivilegedUpdate} source="isCompliant" label="Compliant" />
        <Checkbox isVisible={isPrivilegedUpdate} source="isDataProcessor" label="Is data processor?" />
      </MediumFormRow>

      <MediumFormRow>
        <DateInput
          disabled={!isPrivilegedUpdate}
          source="nextReviewDate"
          label=""
          placeholder="Next review date"
          minDate={tomorrow}
        />
      </MediumFormRow>

      <Divider sx={{ mb: 2, mt: 1 }} />

      <BigFormRow>
        <TextArea source="purpose" placeholder="Purpose" label="" />
      </BigFormRow>

      <Divider sx={{ mb: 2, mt: 1 }} />

      <MediumFormRow>
        <PhoneInput label="" placeholder="General vendor phone" source="phoneNumber" />
        <TextInput label="" placeholder="General vendor email" source="email" />
      </MediumFormRow>

      <BigFormRow>
        <VendorContactsListInput />
      </BigFormRow>

      <Divider sx={{ mb: 2, mt: 1 }} />

      <MediumFormRow>
        <Checkbox
          isVisible={isPrivilegedUpdate}
          source="isAutoApproved"
          label="Performance review and agreement extending is not needed"
        />
      </MediumFormRow>

      <Divider sx={{ mb: 2, mt: 1 }} />
    </Box>
  );
};

export default EditVendorProfile;
